import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-school-top-courses',
  templateUrl: './language-school-top-courses.component.html',
  styleUrls: ['./language-school-top-courses.component.scss']
})
export class LanguageSchoolTopCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
